module.exports = __webpack_public_path__ + "img/addr-select.29b6906e.png";